import * as React from "react"
import { GripVertical } from "lucide-react"
import * as ResizablePrimitive from "react-resizable-panels"

import { cn } from "@/lib/utils"

const ResizablePanelGroup = React.forwardRef(({
  className,
  ...props
}, ref) => (
  <ResizablePrimitive.Group
    ref={ref}
    className={cn(
      "flex h-full w-full data-[panel-group-direction=vertical]:flex-col",
      className
    )}
    {...props} />
))
ResizablePanelGroup.displayName = "ResizablePanelGroup"

/**
 * react-resizable-panels v4 wraps a panel's children in a div with `overflow: auto`, so ANY
 * content that outgrows its panel silently turns the whole pane into a native scroll container
 * — an OS scrollbar across the pane, unrelated to the ScrollArea the pane actually scrolls with
 * (that is how a stray horizontal bar appeared under the Messages thread list). Scrolling in
 * this app belongs to <ScrollArea>, so the wrapper is clipped instead; a pane that genuinely
 * has to scroll natively can still say so through its own `style.overflow`.
 */
const ResizablePanel = ({ style, ...props }) => (
  <ResizablePrimitive.Panel style={{ overflow: "hidden", ...style }} {...props} />
)
ResizablePanel.displayName = "ResizablePanel"

const ResizableHandle = ({
  withHandle,
  className,
  ...props
}) => (
  <ResizablePrimitive.Separator
    className={cn(
      "relative flex w-px items-center justify-center bg-border after:absolute after:inset-y-0 after:left-1/2 after:w-1 after:-translate-x-1/2 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-1 data-[panel-group-direction=vertical]:h-px data-[panel-group-direction=vertical]:w-full data-[panel-group-direction=vertical]:after:left-0 data-[panel-group-direction=vertical]:after:h-1 data-[panel-group-direction=vertical]:after:w-full data-[panel-group-direction=vertical]:after:-translate-y-1/2 data-[panel-group-direction=vertical]:after:translate-x-0 [&[data-panel-group-direction=vertical]>div]:rotate-90",
      className
    )}
    {...props}>
    {withHandle && (
      <div
        className="z-10 flex h-4 w-3 items-center justify-center rounded-sm border bg-border">
        <GripVertical className="h-2.5 w-2.5" />
      </div>
    )}
  </ResizablePrimitive.Separator>
)

export { ResizablePanelGroup, ResizablePanel, ResizableHandle }
